import { useContext, useMemo } from "react";
// contexts
import { CartContext } from "@cart-client/contexts/CartContext";
// types
import { GiftingCartState } from "@cart-client/reducers/GiftingCartReducer";
import { FoodCartItemWithUUID, IMCartItemWithUUID, IMGiftBagItemWithUUID } from "@swiggy-private/cart-types";
// hooks
import { useGetGiftingStoreOOSCart } from "@cart-client/hooks/useGiftingStoreOOSCart";
import { useGiftingSubCartBuilder } from "@cart-client/hooks/useGiftingSubCartBuilder";
// utils
import { createGiftingCartItemListWithUUID } from "@cart-client/helpers/GiftingCart";
import { createGiftingGiftBagItemListWithUUID } from "@cart-client/helpers/GiftingIMSubCart";

export const useGetGiftingCartItemsRenderingProps = () => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart } = cartState as GiftingCartState;
    const { foodCartItems, imCartItems, imGiftBag } = reviewedCart?.data || {};
    const { data: imGiftBagItems } = imGiftBag || {};

    // create cart item list with uuid for food and im items
    const foodCartItemList: FoodCartItemWithUUID[] = useMemo(
        () => createGiftingCartItemListWithUUID(foodCartItems?.items || []) as FoodCartItemWithUUID[],
        [foodCartItems],
    );
    const imCartItemList: IMCartItemWithUUID[] = useMemo(
        () => createGiftingCartItemListWithUUID(imCartItems || []) as IMCartItemWithUUID[],
        [imCartItems],
    );
    const imGiftBagItemList: IMGiftBagItemWithUUID[] = useMemo(
        () => createGiftingGiftBagItemListWithUUID(imGiftBagItems || []) as IMGiftBagItemWithUUID[],
        [imGiftBagItems],
    );

    const { propsForOOSItemList, oosItemCount } = useGetGiftingStoreOOSCart({
        foodCartItemList,
        imCartItemList,
    });

    const { propsForAllInStockItemsCarts, availItemCount, giftBagSelectionHalfCardProps } = useGiftingSubCartBuilder({
        foodCartItemList,
        imCartItemList,
        imGiftBagItemList,
    });

    return {
        propsForOOSItemList,
        propsForAllInStockItemsCarts,
        availItemCount,
        oosItemCount,
        giftBagSelectionHalfCardProps,
        foodCartItemList,
        imCartItemList,
    };
};
